module.exports = __webpack_public_path__ + "static/media/corona2.1d07f1b3.jpeg";